export default "__VITE_ASSET__Ca2qH1ZS__"